angular.module('observatoireApp').controller('ActualitesController', ['$scope', '$timeout', '$sce', 'ActualitesService', function($scope, $timeout, $sce, ActualitesService) {
    // Initialisation des variables
    $scope.actualites = [];
    $scope.filteredActualites = [];
    $scope.displayedActualites = [];
    $scope.featuredActualites = [];
    $scope.recentActualites = [];
    $scope.popularActualites = [];
    $scope.categories = [];
    $scope.selectedCategory = null;
    $scope.searchText = '';
    $scope.currentPage = 1;
    $scope.itemsPerPage = 9;
    $scope.totalItems = 0;
    $scope.totalPages = 1;
    $scope.isLoading = true;
    $scope.hasError = false;
    $scope.errorMessage = null;
    $scope.noResultsMessage = null;
    
    // Méthodes publiques
    $scope.filterByCategory = function(category) {
        // Convertir l'ID de catégorie en nombre pour éviter les problèmes de comparaison
        var categoryId = Number(category);
        
        // Trouver la catégorie sélectionnée
        var selectedCat = $scope.categories.find(function(cat) {
            return Number(cat.id) === categoryId;
        });
        
        console.log('[INFO] Filtrage par catégorie:', selectedCat ? selectedCat.name : 'ID ' + categoryId);
        
        $scope.isLoading = true;
        $scope.selectedCategory = categoryId;
        $scope.applyFilters();
        $scope.isLoading = false;
    };
    
    $scope.search = function() {
        if ($scope.searchText && $scope.searchText.trim() !== '') {
            console.log('Démarrage de la recherche avec le texte:', $scope.searchText);
            $scope.isLoading = true;
            $scope.searchResults = [];
            
            ActualitesService.searchActualites($scope.searchText)
                .then(function(results) {
                    console.log('Résultats de recherche reçus:', results);
                    
                    if (Array.isArray(results) && results.length > 0) {
                        console.log('Nombre de résultats trouvés:', results.length);
                        $scope.searchResults = results;
                        $scope.actualites = results;
                        $scope.selectedCategory = null; // Réinitialiser la catégorie sélectionnée
                        $scope.applyFilters();
                    } else {
                        console.warn('Aucun résultat trouvé ou format inattendu');
                        // Afficher un message si aucun résultat n'est trouvé
                        $scope.searchResults = [];
                        $scope.actualites = [];
                        $scope.filteredActualites = [];
                    }
                    
                    $scope.isLoading = false;
                })
                .catch(function(error) {
                    console.error('Erreur lors de la recherche:', error);
                    $scope.isLoading = false;
                    $scope.searchResults = [];
                    $scope.filteredActualites = [];
                });
        } else {
            // Si le champ de recherche est vide, réinitialiser et afficher toutes les actualités
            console.log('Champ de recherche vide, réinitialisation');
            $scope.resetFilters();
        }
    };
    
    $scope.resetFilters = function() {
        $scope.selectedCategory = null;
        $scope.searchText = '';
        
        // Réinitialiser les résultats de recherche et afficher toutes les actualités
        initialize();
    };
    
    $scope.formatDate = function(dateInput) {
        if (!dateInput) return 'Date inconnue';
        
        var date;
        
        // Cas pour le format spécial de date venant du backend (tableau [année, mois, jour, heure, minute, seconde])
        if (Array.isArray(dateInput) && dateInput.length >= 3) {
            // Format: [year, month, day, hour, minute, second]
            date = new Date(dateInput[0], dateInput[1] - 1, dateInput[2], 
                          dateInput.length > 3 ? dateInput[3] : 0, 
                          dateInput.length > 4 ? dateInput[4] : 0, 
                          dateInput.length > 5 ? dateInput[5] : 0);
        } else {
            // Format ISO ou chaîne de caractères
            date = new Date(dateInput);
        }
        
        // Vérifier si la date est valide
        if (isNaN(date.getTime())) {
            return 'Date inconnue';
        }
        
        // Formater la date au format DD/MM/YYYY
        var day = date.getDate().toString().padStart(2, '0');
        var month = (date.getMonth() + 1).toString().padStart(2, '0');
        var year = date.getFullYear();
        
        return day + '/' + month + '/' + year;
    };
    
    $scope.goToPage = function(page) {
        if (page < 1) page = 1;
        if (page > $scope.totalPages) page = $scope.totalPages;
        
        $scope.currentPage = page;
        $scope.updateDisplayedActualites();
    };
    
    $scope.viewActualite = function(id) {
        console.log('Affichage de l\'actualité avec ID:', id);
        ActualitesService.getActualiteById(id)
            .then(function(actualite) {
                console.log('Actualité reçue du service:', actualite);
                
                // Formater l'actualité pour l'affichage
                // Faire une copie pour éviter de modifier l'original directement
                $scope.selectedActualite = angular.copy(actualite);
                
                // Débogage des champs principaux
                console.log('ID:', $scope.selectedActualite.id);
                console.log('Titre:', $scope.selectedActualite.title);
                console.log('Résumé:', $scope.selectedActualite.summary);
                console.log('Contenu:', typeof $scope.selectedActualite.content, $scope.selectedActualite.content ? $scope.selectedActualite.content.substring(0, 100) + '...' : 'null');
                console.log('Image:', $scope.selectedActualite.image);
                console.log('Catégorie:', $scope.selectedActualite.category);
                console.log('Auteur:', $scope.selectedActualite.authorDisplay || $scope.selectedActualite.author);
                console.log('Date:', $scope.selectedActualite.date);
                
                // Assurer que tous les champs nécessaires sont présents
                if (!$scope.selectedActualite.title) {
                    $scope.selectedActualite.title = 'Sans titre';
                }
                
                if (!$scope.selectedActualite.summary) {
                    $scope.selectedActualite.summary = 'Aucun résumé disponible.';
                }
                
                if (!$scope.selectedActualite.content) {
                    $scope.selectedActualite.content = '<p>Aucun contenu disponible.</p>';
                }
                
                if (!$scope.selectedActualite.image) {
                    $scope.selectedActualite.image = 'assets/images/placeholder.jpg';
                }
                
                if (!$scope.selectedActualite.category) {
                    $scope.selectedActualite.category = 'Non classé';
                }
                
                if (!$scope.selectedActualite.authorDisplay && !$scope.selectedActualite.author) {
                    $scope.selectedActualite.authorDisplay = 'Admin';
                }
                
                if (!$scope.selectedActualite.views) {
                    $scope.selectedActualite.views = 0;
                }
                
                // Convertir le contenu HTML en contenu sécurisé pour l'affichage
                $scope.selectedActualite.trustedContent = $sce.trustAsHtml($scope.selectedActualite.content || '<p>Aucun contenu disponible.</p>');
                
                // Incrémenter le compteur de vues
                $scope.incrementViews(id);
                
                // Force Angular à mettre à jour la vue
                if (!$scope.$$phase) {
                    $scope.$apply();
                }
                
                // Afficher le modal avec le bon ID
                var el = document.getElementById('actualiteDetailModal');
                if (el) bootstrap.Modal.getOrCreateInstance(el).show();
            })
            .catch(function(error) {
                console.error('Erreur lors de la récupération de l\'actualité:', error);
            });
    };
    
    // Fonction pour afficher le détail d'une actualité (utilisée dans la section "Dernières actualités")
    $scope.showActualiteDetail = function(actualite) {
        if (!actualite || !actualite.id) {
            console.error('Impossible d\'afficher le détail : actualité invalide', actualite);
            return;
        }
        
        console.log('[INFO] Affichage du détail de l\'actualité:', actualite.id, actualite.title);
        $scope.viewActualite(actualite.id);
    };
    
    /**
     * Ferme le modal d'affichage des détails d'une actualité
     */
    $scope.closeActualiteModal = function() {
        console.log('Fermeture du modal d\'actualité');
        var el = document.getElementById('actualiteDetailModal');
        if (el) { var m = bootstrap.Modal.getInstance(el); if (m) m.hide(); }
    };
    
    $scope.incrementViews = function(id) {
        ActualitesService.incrementViews(id)
            .catch(function(error) {
                console.error('Erreur lors de l\'incrémentation des vues:', error);
            });
    };
    
    /**
     * Retourne l'URL pour partager une actualité
     * @param {number} id - L'identifiant de l'actualité
     * @returns {string} L'URL de partage encodée
     */
    $scope.getShareUrl = function(id) {
        // Construire l'URL absolue pour le partage (sera encodée par Angular)
        var baseUrl = window.location.origin;
        var appUrl = baseUrl + '/#!/actualites/' + id;
        return appUrl;
    };
    
    // Méthodes privées exposées pour les tests
    $scope.updateDisplayedActualites = function() {
        // Calculer les indices de début et de fin pour la pagination
        var startIndex = ($scope.currentPage - 1) * $scope.itemsPerPage;
        var endIndex = startIndex + $scope.itemsPerPage;
        
        // S'assurer que les indices sont valides
        if (startIndex < 0) startIndex = 0;
        if (endIndex > $scope.filteredActualites.length) {
            endIndex = $scope.filteredActualites.length;
        }
        
        // Vérifier si les actualités filtrées ont du contenu
        if ($scope.filteredActualites.length === 0 && $scope.actualites.length > 0) {
            // Afficher un message pour indiquer qu'aucun résultat n'a été trouvé
            // mais ne pas réinitialiser automatiquement les filtres
            $scope.noResultsMessage = "Aucune actualité ne correspond aux critères de filtrage.";
        } else {
            // Réinitialiser le message s'il y a des résultats
            $scope.noResultsMessage = null;
        }
        
        // Mettre à jour les informations de pagination
        $scope.totalItems = $scope.filteredActualites.length;
        $scope.totalPages = Math.ceil($scope.totalItems / $scope.itemsPerPage);
        
        // Si la page actuelle est supérieure au nombre total de pages, revenir à la première page
        if ($scope.currentPage > $scope.totalPages && $scope.totalPages > 0) {
            $scope.currentPage = 1;
            startIndex = 0;
            endIndex = $scope.itemsPerPage;
            if (endIndex > $scope.filteredActualites.length) {
                endIndex = $scope.filteredActualites.length;
            }
        }
        
        // Vider le tableau existant et le remplir avec les éléments de la page actuelle
        $scope.displayedActualites = $scope.filteredActualites.slice(startIndex, endIndex);
    };
    
    // Appliquer les filtres aux actualités
    $scope.applyFilters = function() {
        // Si aucune catégorie n'est sélectionnée, afficher toutes les actualités
        if ($scope.selectedCategory === null) {
            $scope.filteredActualites = $scope.actualites;
        } else {
            // Filtrer par catégorie sélectionnée
            var selectedCategoryId = Number($scope.selectedCategory);
            
            $scope.filteredActualites = $scope.actualites.filter(function(actualite) {
                // 1. Vérifier dans le tableau categories
                if (actualite.categories && Array.isArray(actualite.categories) && actualite.categories.length > 0) {
                    return actualite.categories.some(function(cat) {
                        var catId = typeof cat === 'object' && cat !== null ? 
                                  Number(cat.id) : Number(cat);
                        return catId === selectedCategoryId;
                    });
                }
                
                // 2. Vérifier dans l'objet category
                if (actualite.category) {
                    if (typeof actualite.category === 'object' && actualite.category !== null) {
                        return Number(actualite.category.id) === selectedCategoryId;
                    } else {
                        return Number(actualite.category) === selectedCategoryId;
                    }
                }
                
                // 3. Vérifier dans categoryId
                if (actualite.categoryId !== undefined && actualite.categoryId !== null) {
                    return Number(actualite.categoryId) === selectedCategoryId;
                }
                
                return false;
            });
        }
        
        // Appliquer le filtre de recherche texte si nécessaire
        if ($scope.searchText && $scope.searchText.trim() !== '') {
            var textToSearch = $scope.searchText.trim().toLowerCase();
            $scope.filteredActualites = $scope.filteredActualites.filter(function(actualite) {
                return (actualite.title && actualite.title.toLowerCase().includes(textToSearch)) || 
                      (actualite.content && actualite.content.toLowerCase().includes(textToSearch)) || 
                      (actualite.summary && actualite.summary.toLowerCase().includes(textToSearch));
            });
        }
        
        // Mettre à jour les variables de pagination
        $scope.totalItems = $scope.filteredActualites.length;
        $scope.currentPage = 1;
        $scope.totalPages = Math.ceil($scope.totalItems / $scope.itemsPerPage) || 1;
        
        // Mettre à jour les actualités affichées
        $scope.updateDisplayedActualites();
    };
    
    // Comptage des catégories
    function updateCategoryCounts() {
        // Réinitialiser les compteurs
        if ($scope.categories && $scope.categories.length > 0) {
            $scope.categories.forEach(function(cat) {
                cat.count = 0;
            });
            
            // Compter les actualités pour chaque catégorie
            $scope.actualites.forEach(function(actualite) {
                // 1. Vérifier dans le tableau categories
                if (actualite.categories && Array.isArray(actualite.categories) && actualite.categories.length > 0) {
                    actualite.categories.forEach(function(cat) {
                        var catId = typeof cat === 'object' && cat !== null ? 
                                 Number(cat.id) : Number(cat);
                        
                        var category = $scope.categories.find(function(c) {
                            return Number(c.id) === catId;
                        });
                        
                        if (category) {
                            category.count++;
                        }
                    });
                } 
                // 2. Vérifier dans l'objet category ou categoryId
                else {
                    var catId = null;
                    
                    if (actualite.category) {
                        if (typeof actualite.category === 'object' && actualite.category !== null) {
                            catId = Number(actualite.category.id);
                        } else {
                            catId = Number(actualite.category);
                        }
                    } else if (actualite.categoryId !== undefined && actualite.categoryId !== null) {
                        catId = Number(actualite.categoryId);
                    }
                    
                    if (catId !== null) {
                        var category = $scope.categories.find(function(c) {
                            return Number(c.id) === catId;
                        });
                        
                        if (category) {
                            category.count++;
                        }
                    }
                }
            });
            
            console.log('[INFO] Compteurs de catégories mis à jour:', 
                       $scope.categories.map(function(cat) { 
                           return cat.name + ': ' + cat.count; 
                       }).join(', '));
        }
    }
    
    // Initialisation
    function initialize() {
        $scope.isLoading = true;
        
        // Charger les catégories
        ActualitesService.getCategories()
            .then(function(categories) {
                $scope.categories = categories.map(function(cat) {
                    return {
                        id: Number(cat.id),
                        name: cat.name,
                        slug: cat.slug,
                        description: cat.description || '',
                        color: cat.color || cat.colorCode || '#007bff',
                        icon: cat.icon || cat.iconUrl || '',
                        count: 0
                    };
                });
                
                // Vérifier si la catégorie "Non classé" existe déjà
                var hasUncategorized = $scope.categories.some(function(cat) {
                    return cat.name === 'Non classé' || cat.slug === 'non-classe';
                });
                
                // Ajouter la catégorie "Non classé" si elle n'existe pas
                if (!hasUncategorized) {
                    $scope.categories.push({
                        id: -1,
                        name: 'Non classé',
                        slug: 'non-classe',
                        description: 'Actualités sans catégorie',
                        count: 0,
                        isUncategorized: true
                    });
                }
                
                console.log('[INFO] Catégories chargées:', $scope.categories.length);
                
                // Charger toutes les actualités
                return ActualitesService.getAllActualites();
            })
            .then(function(actualites) {
                $scope.actualites = actualites;
                console.log('[INFO] Actualités chargées:', actualites.length);
                
                // Mettre à jour les compteurs de catégories
                updateCategoryCounts();
                
                // Appliquer les filtres
                $scope.applyFilters();
                
                // Charger les actualités mises en avant
                return ActualitesService.getFeaturedActualites();
            })
            .then(function(featured) {
                $scope.featuredActualites = featured;
                
                // Utiliser les actualités déjà chargées mais triees par date au lieu d'appeler l'API
                if ($scope.actualites && $scope.actualites.length > 0) {
                    console.log('[INFO] Utilisation des actualités existantes pour la section "Dernières actualités"');
                    // Créer une copie pour éviter de modifier le tableau original
                    var recentActualites = $scope.actualites.slice();
                    
                    // Trier par date (de la plus récente à la plus ancienne)
                    recentActualites.sort(function(a, b) {
                        var dateA = new Date(a.date);
                        var dateB = new Date(b.date);
                        return dateB - dateA; // Tri décroissant
                    });
                    
                    // Limiter à 5 actualités
                    $scope.recentActualites = recentActualites.slice(0, 5);
                    console.log('[DEBUG] Actualités récentes:', $scope.recentActualites.length);
                } else {
                    // Fallback au cas où
                    return ActualitesService.getRecentActualites();
                }
            })
            .then(function(recent) {
                // Ne pas écraser les actualités récentes si déjà définies
                if (recent && !$scope.recentActualites) {
                    $scope.recentActualites = recent;
                }
                return ActualitesService.getMostViewedActualites();
            })
            .then(function(popular) {
                $scope.popularActualites = popular;
                $scope.isLoading = false;
            })
            .catch(function(error) {
                console.error('[ERROR] Erreur lors de l\'initialisation:', error);
                $scope.hasError = true;
                $scope.errorMessage = 'Erreur lors du chargement des données. Veuillez réessayer plus tard.';
                $scope.isLoading = false;
            });
    }
    
    // Initialiser le contrôleur
    initialize();
    // Fonctions de pagination
    $scope.setPage = function(page) {
        if (page < 1 || page > $scope.totalPages) {
            return;
        }
        $scope.currentPage = page;
        $scope.updateDisplayedActualites();
    };
    
    $scope.previousPage = function() {
        if ($scope.currentPage > 1) {
            $scope.currentPage--;
            $scope.updateDisplayedActualites();
        }
    };
    
    $scope.nextPage = function() {
        if ($scope.currentPage < $scope.totalPages) {
            $scope.currentPage++;
            $scope.updateDisplayedActualites();
        }
    };
    
    $scope.getPageRange = function() {
        var pages = [];
        var maxPageButtons = 5; // Nombre maximum de boutons de page à afficher
        
        // Calculer les pages de début et de fin à afficher
        var startPage = Math.max(1, $scope.currentPage - Math.floor(maxPageButtons / 2));
        var endPage = Math.min($scope.totalPages, startPage + maxPageButtons - 1);
        
        // Ajuster startPage si endPage est à la fin
        if (endPage - startPage + 1 < maxPageButtons) {
            startPage = Math.max(1, endPage - maxPageButtons + 1);
        }
        
        $scope.startPage = startPage;
        $scope.endPage = endPage;
        
        for (var i = startPage; i <= endPage; i++) {
            pages.push(i);
        }
        
        return pages;
    };
}]);
